'use es6';

import { List, Record } from 'immutable';
import { ContentTypes } from '../constants/ContentConstants';
export default Record({
  assetId: null,
  classId: null,
  completed: false,
  contentType: ContentTypes.VIDEO,
  description: null,
  displayOrder: null,
  duration: null,
  id: null,
  language: null,
  name: null,
  professors: List(),
  // todo: remove once the API returns professors at root level
  url: null,
  reference: null,
  referenceType: null,
  vidyardUuid: null,
  hubId: null,
  wistiaId: null
}, 'Video');